module.exports = __webpack_public_path__ + "product/icon-zoom-grey-4e184bce742f19f632dd0956c1fba3e7.svg";